import {
  MainnetLockingContract,
  PulseLockingContract,
  PulseTestLockingContract,
  TestLockingContract,
  TestMainWaitContract,
  TestWaitContract,
  WaitContract,
} from 'libs/data/contracts'
import { useChainId } from 'wagmi'

import useApproved from './useApproved'
import useWrite from './useWrite'

export default (number, func): any => {
  const chainId = useChainId()
  const approved = useApproved()
  const addr =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? PulseTestLockingContract.address
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestLockingContract.address
        : chainId == 1
          ? MainnetLockingContract.address
          : PulseLockingContract.address
  const abi =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? TestWaitContract.abi
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestMainWaitContract.abi
        : chainId == 1
          ? WaitContract.abi
          : WaitContract.abi
  const waitAddress =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? TestWaitContract.address
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestMainWaitContract.address
        : process.env.NEXT_PUBLIC_ENV != 'development'
          ? WaitContract.address
          : WaitContract.address

  // console.log('aaddr', addr)
  // console.log('abai', abi)
  // console.log('waiaatAddress', waitAddress)

  return useWrite({
    contract: waitAddress,
    abi: abi,
    functionName: 'approve',
    loading: approved.state === 'loading',
    enabled: true,
    args: [addr, number],
    onTransactionComplete: () => {
      func()
    },
  })
}
